module.exports = __webpack_public_path__ + "static/media/Spain_bell_beaker_icon_200px.3d44fc1f.png";